export const FOCUS_POINT = 'focusPoint'
export const FOCUS_AREA = 'focusArea'
